(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/stream-player/assets/javascripts/preload-stream.js') >= 0) return;  svs.modules.push('/components/racing/stream-player/assets/javascripts/preload-stream.js');

'use strict';

const StreamPlayerPreloader = props => React.createElement("div", {
  className: "stream-player-preloader ",
  style: {
    backgroundImage: "url(".concat(props.preloadImage, ")")
  }
}, React.createElement("div", {
  className: "stream-player-preloader-play margin-xs-bottom-1"
}, React.createElement("i", {
  className: "icon icon-900 icon-inverted icon-play",
  onClick: () => props.loadPlayer(true)
})), React.createElement("div", {
  className: "stream-player-preloader-bottom"
}, React.createElement("div", {
  className: "stream-player-preloader-bottom-left"
}, React.createElement("i", {
  className: "icon icon-100 icon-marker fc-red"
}), React.createElement("span", null, "LIVE")), svs.core.detect.formfactor.mobile() && React.createElement("div", {
  className: "stream-player-preloader-bottom-right"
}, React.createElement("i", {
  className: "icon icon-300 icon-inverted icon-menu-up",
  onClick: () => props.onFold()
}))));
svs.racing.streamplayer.StreamPlayerPreloader = StreamPlayerPreloader;

 })(window);